import { state } from '../state'
import { cache } from './cache'
import { ensureById } from '@webapp2/shared/services/documents-by-id'

export async function ensurePlayerTechniques(techniqueIds: string[]) {
  const loaded = await ensureById('PlayerTechnique', state.playerTechniques, techniqueIds)
  await cache.setItems(loaded)
}
